import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({ 
  "shared-facilities-setting-container":{
        width: "100%"
    },
    "shared-facilities-setting-header": {
        display: "flex",
        justifyContent: "felx-start",
        gap: "1px",
        alignItems: "center",
        flexWrap: "wrap",
        marginBottom: theme.spacing(2),
        "& h6": {
            fontSize: "1.15rem",
            color: theme.palette.primary.main,
        },
        "& svg": {
            marginBottom: "0.1rem",
        }
    },
}));
